import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

const QuestionType = ({
  questionData,
  handleChange,
  questionTypes,
  questionTypeDescriptions,
  baseQuestion
}) => {
  return (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel>Question Type</InputLabel>
        <Select
          value={questionData.questionType || ""}
          onChange={(e) => handleChange("questionType", e.target.value)}
          disabled={baseQuestion}
        >
          <MenuItem value="">Select Question Type</MenuItem>
          {questionTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {questionData.questionType && (
        <Typography variant="caption" color="textSecondary">
          {questionTypeDescriptions[questionData.questionType]}
        </Typography>
      )}
    </Grid>
  );
};

export default QuestionType;
